// extracted by mini-css-extract-plugin
export default {"container":"jV-z","header":"kV-z","details":"lV-z","link":"mV-z"};